<template>
  <div id="page-poll-preview" class="poll-preview-overlay news-page">

    <header class="masthead masthead--compact">
      <div class="masthead__rule masthead__rule--thick"></div>
      <div class="masthead__inner masthead__inner--row">
        <button type="button" class="poll-show__back-btn" @click="$emit('close')">
          ← Înapoi la formular
        </button>
      </div>
      <div class="masthead__rule masthead__rule--thin"></div>
    </header>

    <div class="poll-preview__notice mb-3">
      {{ isEdit ? 'Previzualizare — modificările nu au fost aplicate încă.' : 'Previzualizare — sondajul nu a fost publicat încă.' }}
    </div>

    <section class="poll-show__body">
      <div class="poll-show__title-card">
        <h1 class="poll-show__question">{{ poll.title }}</h1>
      </div>

      <div class="poll-show__below-card">
        <ul class="poll-show__options" role="listbox" aria-label="Variante de răspuns">
          <li v-for="(option, idx) in poll.options" :key="idx" class="poll-option poll-option--disabled">
            <span class="poll-option__marker"></span>
            <span class="poll-option__label">{{ option.title }}</span>
          </li>
        </ul>
      </div>
    </section>

    <StickyFooter :show="true">
      <div class="poll-form__sticky-bar-inner">
        <button type="button" class="poll-form__publish-btn" :disabled="submitting" @click="$emit('publish')">
          {{ isEdit ? 'Confirmă modificările' : (submitting ? 'Se publică...' : 'Publică sondaj') }}
        </button>
      </div>
    </StickyFooter>

  </div>
</template>

<script>
import StickyFooter from '@app/components/StickyFooter.vue';

export default {
  components: { StickyFooter },

  props: {
    poll:       { type: Object,  required: true },
    isEdit:     { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
  },

  emits: ['close', 'publish'],
};
</script>
